var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemperatura(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 57,
    viewBox: "0 0 33 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.53497 49.7009C2.53497 46.5687 4.32693 43.8573 6.94385 42.529L6.96023 17.5964H4.40342V40.9984C1.79196 42.3267 0 45.0381 0 48.1703C0 51.6306 2.19078 54.577 5.25569 55.7141C3.59485 54.2381 2.54043 52.0953 2.54043 49.6955L2.53497 49.7009Z",
    fill: "#E24B5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97113 0.174805C5.49058 0.639454 4.40338 2.00605 4.40338 3.64052V17.5964H6.9602L6.97113 0.174805Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96018 17.5964L6.94379 42.529C4.33233 43.8628 2.53491 46.5687 2.53491 49.7009C2.53491 52.0953 3.58933 54.2436 5.25017 55.7195C6.11884 56.0475 7.05852 56.2279 8.04192 56.2279C12.4836 56.2279 16.0894 52.6255 16.0894 48.1758C16.0894 45.0381 14.2974 42.3322 11.6859 41.0038V17.6019H6.96018V17.5964Z",
    fill: "#BC224E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04203 0C7.66507 0 7.30995 0.071068 6.96576 0.174931L6.95483 17.5965H11.6806V3.64065C11.6806 1.62899 10.0525 0 8.03656 0H8.04203Z",
    fill: "#BEC4CE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8685 41.9607C27.6279 41.9607 28.278 41.8349 28.8244 41.578C29.3707 41.3266 29.9444 40.9166 30.5399 40.359L31.9548 41.8131C30.5726 43.3437 28.9009 44.109 26.9341 44.109C24.9673 44.109 23.3338 43.4749 22.0335 42.2066C20.7387 40.9384 20.0886 39.3368 20.0886 37.3962C20.0886 35.4556 20.7496 33.8484 22.0717 32.5474C23.3939 31.2573 25.0602 30.6123 27.0816 30.6123C29.0975 30.6123 30.7857 31.3557 32.1406 32.8481L30.742 34.3787C30.1246 33.7829 29.5346 33.3674 28.9828 33.1269C28.431 32.8973 27.7809 32.7716 27.0379 32.7716C25.7212 32.7716 24.6176 33.1979 23.7217 34.0507C22.8257 34.9035 22.3777 35.9858 22.3777 37.3142C22.3777 38.6371 22.8202 39.7413 23.7053 40.6269C24.5958 41.5179 25.6502 41.9607 26.8631 41.9607H26.8685Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1712 31.9458C16.4336 31.9458 15.8327 31.3499 15.8327 30.612C15.8327 29.874 16.4336 29.2727 17.1712 29.2727C17.9087 29.2727 18.5097 29.874 18.5097 30.612C18.5097 31.3499 17.9142 31.9458 17.1712 31.9458ZM17.1712 27.6929C15.5595 27.6929 14.2538 28.9994 14.2538 30.612C14.2538 32.2191 15.5595 33.5256 17.1712 33.5256C18.7829 33.5256 20.0886 32.2191 20.0886 30.612C20.0886 28.9994 18.7829 27.6929 17.1712 27.6929Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08569 21.0677H11.686V19.6082H8.08569V21.0677Z",
    fill: "#DEF0FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08569 25.2112H11.686V23.7517H8.08569V25.2112Z",
    fill: "#DEF0FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08569 29.3548H11.686V27.8953H8.08569V29.3548Z",
    fill: "#DEF0FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08569 33.5038H11.686V32.0388H8.08569V33.5038Z",
    fill: "#DEF0FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08569 37.6422H11.686V36.1826H8.08569V37.6422Z",
    fill: "#DEF0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatura);
export default __webpack_public_path__ + "static/media/temperatura.ed7ea578a8d37d2462ae0d00dfcb5366.svg";
export { ForwardRef as ReactComponent };